import { LatLng } from "leaflet";
import distance from "@turf/distance";
import { point } from "@turf/helpers";

class Bounds {
  constructor(public polygonGeometry: LatLng[]) {
    const latitudes = polygonGeometry.map((p) => p.lat);
    const longitudes = polygonGeometry.map((p) => p.lng);
    this.latMin = Math.min(...latitudes);
    this.latMax = Math.max(...latitudes);
    this.lngMin = Math.min(...longitudes);
    this.lngMax = Math.max(...longitudes);
  }

  latMin: number;
  latMax: number;
  lngMin: number;
  lngMax: number;

  isSame(other: Bounds): boolean {
    return (
      this.latMin === other.latMin &&
      this.latMax === other.latMax &&
      this.lngMin === other.lngMin &&
      this.lngMax === other.lngMax
    );
  }
  swPoint = () => point([this.lngMin, this.latMin]);
  nwPoint = () => point([this.lngMin, this.latMax]);
  nePoint = () => point([this.lngMax, this.latMax]);
  sePoint = () => point([this.lngMax, this.latMin]);
  width = () => distance(this.nwPoint(), this.nePoint(), { units: "meters" }) || 0;
  height = () => distance(this.nwPoint(), this.swPoint(), { units: "meters" }) || 0;
}

export default Bounds;
